import {
  AdditionBoqStateTypes,
  AdditionBoqActionTypes,
} from "./AdditionBoq.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AdditionBoqStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AdditionBoqReducer = (
  state: AdditionBoqStateTypes = INITIAL_STATE,
  action: any
): AdditionBoqStateTypes => {
  switch (action.type) {
    case AdditionBoqActionTypes.FETCH_ALL_ADDITION_BOQ:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AdditionBoqActionTypes.FETCH_ALL_ADDITION_BOQ_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AdditionBoqActionTypes.FETCH_ALL_ADDITION_BOQ_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AdditionBoqActionTypes.FETCH_ALL_ADDITION_BOQ_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AdditionBoqActionTypes.FETCH_ONE_ADDITION_BOQ:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AdditionBoqActionTypes.FETCH_ONE_ADDITION_BOQ_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AdditionBoqActionTypes.FETCH_ONE_ADDITION_BOQ_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AdditionBoqActionTypes.FETCH_ONE_ADDITION_BOQ_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AdditionBoqReducer;
